import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode:'history',
	routes: [
	    {
	      path: '/',
	      name: 'index',
	      component: resolve => require(['@/pages/index/index'], resolve)
	    },
	    {
	      path: '/apply',
	      name: 'apply',
	      component: resolve => require(['@/pages/apply/apply'], resolve)
	    },
	    {
	      path: '/other',
	      name: 'other',
	      component: resolve => require(['@/pages/other/other'], resolve)
	    },
	    {
	      path: '/success',
	      name: 'success',
	      component: resolve => require(['@/components/submit'], resolve)
	    }
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js